<div class="dashboard">
  <!-- Common No Data Template -->
  <ng-template #commonNoDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <h2 class="empty-state-title" *ngIf="!isLoading">
          {{ errorMsg }}
        </h2>
        <img [src]="imageSrc" alt="No records illustration" class="empty-state-image" />
      </div>
    </section>
  </ng-template>

  <div class="grid-layout">
    <!-- Skills Distribution Section -->
    <div class="section skills-section">
      <div class="top-vendors">
        <div class="container">
          <div class="metric-header">
            <h2>{{ peopleMetricsLabels.skills }}</h2>
          </div>
          <div class="chart-container" *ngIf="
              !isLoading &&
                isDataLoaded &&
                chartData?.datasets[0]?.data?.length > 0;
              else commonNoDataTemplate" style="display: flex; flex-direction: column; align-items: center;">
            <p-chart type="doughnut" [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins"
              class="doughnut-chart"></p-chart>
            <div class="org-level-message">
              <p>*{{ orgLevelMessage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Metrics Section - Restricted to Level 2 or 3 users -->
      <div class="section metrics-section" *ngIf="hasLevel2Or3Access">
        <div class="container">
          <div class="header">
            <div class="tab-icon">
              <h2>{{ peopleMetricsLabels.metrics }}</h2>
            </div>
            <emerald-dropdown [outlined]="true" [id]="'metrics_month_select'" [label]="'Quarter'" [options]="metricsMonth"
            (onChange)="onMetricsMonthSelect($event)" [isValid]="true" class="mobile-dropdown"></emerald-dropdown>
        </div>
      </div>
        <div class="metrics-grid">
          <div class="metrics-content" *ngIf="!isLoading; else commonNoDataTemplate">
            <ng-container *ngIf="metrics && metrics.length > 0; else commonNoDataTemplate">
              <div class="metric-data">
                <div class="metric-card" *ngFor="let metric of metrics; let i = index">
                  <div class="metric-content">
                    <span class="metric-label">{{ metric.label }}</span>
                    <span class="metric-value">{{ metric.value }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
